export default {
    state: {
        type: "",
        currentStage: 0,
        stageCount: 0,
        settings: {},
        stages: [],
        transitioning: false
    },
    mutations: {
        setCurrentStage(state, currentStage) {
            state.currentStage = currentStage;
        },
        setBlockType(state, type) {
            state.type = type;
        },
        setBlockSettings(state, settings) {
            state.settings = settings;
        },
        setTransitioning(state, bool) {
            state.transitioning = bool;
        },
        setBlockStages(state, stageArray) {
            if (!Array.isArray(stageArray)) {
                console.log("Trying to add stages but it is not an array");
                state.stages = [];
                state.stageCount = state.stages.length;
                return;
            }
            state.stages = stageArray;
            state.stageCount = state.stages.length;
        }
    },
    actions: {
        setBlockData(store, data) {
            return new Promise((resolve, reject) => {
                console.log('setBlockData: hide_intro:');
                console.log(data.stages[0].data.hide_intro);
                console.log(data.stages[0].data.use == "No");
                
                if (
                    data.blockType == "gameblock" &&
                    data.stages[0].type == "Intro" &&
                    data.stages[0].data.hide_intro == "Yes"
                ) {
                    store.commit("setCurrentStage", 1);
                }
                else if(
                    data.blockType == "dcp" &&
                    data.stages[0].type == "Sdg" &&
                    data.stages[0].data.use == "No"
                ) {
                    store.commit("setCurrentStage", 1);
                } else {
                    store.commit("setCurrentStage", 0);
                }

                store.commit("setBlockType", data.blockType);
                store.commit("setBlockSettings", data.settings);
                store.commit("setBlockStages", data.stages);
                if (store.state.stages[store.state.currentStage] == undefined) {
                    reject("No stage data in block.");
                } else {
                    this.dispatch(
                        "setStageData",
                        store.state.stages[store.state.currentStage]
                    ).then(() => {
                        resolve();
                    });
                }
            });
        },

        toNextStage(store) {
            return new Promise((resolve, reject) => {
                store.commit("setCurrentStage", store.state.currentStage + 1);
                store
                    .dispatch(
                        "setStageData",
                        store.state.stages[store.state.currentStage]
                    )
                    .then(() => {
                        let stageType = store.getters.stageType;
                        let blockSettings = store.getters.blockSettings;

                        let useScore = "No";
                        if(typeof blockSettings.score !== 'undefined'){
                            useScore =
                                blockSettings == null
                                    ? "No"
                                    : blockSettings.score.use;
                        }

                        if (stageType == "Score" && useScore == "No") {
                            console.log("Skip totem");
                            store.dispatch("toNextBlock").then(() => {
                                resolve();
                            });
                        } else {
                            resolve();
                        }
                    });
            });
        },

        startBlockTransition(store) {
            return new Promise((resolve, reject) => {
                store.commit("setTransitioning", true);
                resolve();
            });
        },
        stopBlockTransition(store) {
            return new Promise((resolve, reject) => {
                store.commit("setTransitioning", false);
                resolve();
            });
        }
    },
    getters: {
        blockType(state) {
            return state.type;
        },
        blockSettings(state) {
            return state.settings;
        },
        blockTransitioning(state) {
            return state.transitioning;
        },
        lastStage(state) {
            return state.currentStage >= state.stageCount - 1;
        },
        currentStage(state) {
            return state.currentStage;
        },
        stageCount(state) {
            return state.stageCount;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/block.js